import { PortfolioList } from '@types'

export const getSlidersForSuccessSections = (
  lists: PortfolioList[],
  arrayIds: string[]
) => lists.filter(item => arrayIds.some(value => value === item.id))
